import { render, staticRenderFns } from "./VideoCoverBlock.vue?vue&type=template&id=4543f300&scoped=true"
import script from "./VideoCoverBlock.vue?vue&type=script&lang=js"
export * from "./VideoCoverBlock.vue?vue&type=script&lang=js"
import style0 from "./VideoCoverBlock.vue?vue&type=style&index=0&id=4543f300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543f300",
  null
  
)

export default component.exports